import styled from "styled-components";

export const CarouselWrapper = styled.div`
 
  .swiper {
    margin-bottom: 0 !important; 
  }
`;

export const SlideContainer = styled.div`
  width: 100%;
  height: 450px; 
  background-color: #02391E;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    height: auto; 
    padding: 40px 0; 
`;

export const CarouselContainer = styled.div`
  width: 100%;
  .slick-dots {
    bottom: 25px;
    li button:before {
      font-size: 12px;
      color: white;
      opacity: 0.75;
    }
    li.slick-active button:before {
      color: white;
      opacity: 1;
    }
  }
`;

export const SlideItem = styled.div`
  width: 100%;
  height: 600px; 
  background-color: #02391E; 
  display: flex;
  align-items: center;
  position: relative; 
`;


export const BackgroundImage = styled.img`
  position: absolute;
  bottom: 20px; 
  right: 20px; 
  width: 200px; 
  height: auto;
  opacity: 0.3; 
  z-index: 1; 
`;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  width: 100%;
  gap: 50px;
  position: relative; 
  z-index: 2; 

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #ffffff;

  h1 {
    color: #FED15D; 
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  p {
    font-size: 18px;
    max-width: 500px;
    line-height: 1.5;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    order: 2;
    align-items: center;
    h1 {
      font-size: 36px;
    }
    p {
      font-size: 16px;
      max-width: 100%;
    }
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  
 
  @media screen and (max-width: 768px) {
    order: 1; 
    height: auto;
    padding-top: 20px;
`;


export const ManImage = styled.img`
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
  position: relative; 
  z-index: 2; 

  @media screen and (max-width: 768px) {
    max-height: 250px;
  }
`;


export const PanelImageBackground = styled.img`
    width: 300px; 
  height: auto;
  position: absolute;
  z-index: 1; 
  opacity: 0.7;
  top: 60%; 
  right: 32%; 
  transform: translateY(-100%);
border-radius: 16px;

@media screen and (max-width: 768px) {
right: 50%; 
left: 45%;
transform: translate(-50%, -80%);
opacity: 0.4;
}


`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-start; 

  


  @media screen and (max-width: 768px) {
    flex-direction: column;  
    align-items: center;     
    gap: 15px;

   
    & > a {
      width: 80%;
      max-width: 300px;
    }
  }
`;

export const CourseDiagramImage = styled.img`

  width: 70%;
  height: 70%;
  height: auto;
 
  position: relative; 
  z-index: 2;
 
  
  

  @media screen and (max-width: 768px) {
    max-width: 280px;
    margin-top: 30px;
    padding: 15px;
  }
`;